import { NavLink, Outlet } from 'react-router-dom';

/**
 * SettingsLayout — left sub-nav + content outlet.
 *
 * Five sections:
 *   - Organisation  (rename, change slug, contact email)
 *   - Team          (admins, invitations)
 *   - Security      (password, email change)
 *   - Billing       (plan, card, invoices)
 *   - Danger zone   (delete account — intentionally separated)
 *
 * Danger zone gets visual distinction (red) to signal its nature.
 */

const SETTINGS_NAV = [
  { to: '/dashboard/settings/organisation', label: 'Organisation' },
  { to: '/dashboard/settings/team',         label: 'Team' },
  { to: '/dashboard/settings/security',     label: 'Security' },
  { to: '/dashboard/settings/billing',      label: 'Billing' },
  { to: '/dashboard/settings/id-cards',    label: 'ID Cards' },
  { to: '/dashboard/settings/danger',       label: 'Danger zone', danger: true },
];

export function SettingsLayout() {
  return (
    <>
      <div className="page-header">
        <div className="page-title-wrap">
          <h1 className="page-title">Settings</h1>
          <p className="page-subtitle">
            Manage your organisation, team, security, and billing.
          </p>
        </div>
      </div>

      <div className="settings-layout">
        <nav className="settings-subnav" aria-label="Settings sections">
          <ul className="settings-subnav-list">
            {SETTINGS_NAV.map(item => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    `settings-subnav-link ${item.danger ? 'danger' : ''} ${isActive ? 'active' : ''}`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="settings-main">
          <Outlet />
        </div>
      </div>
    </>
  );
}
